import AbstractModel, { Model } from './abstract-model';

@Model('BeanExportPdf')
export default class BeanExportPdf extends AbstractModel {
  public includeMap: boolean = true;
  public includeAccesPossibles: boolean = true;
  public includeDescriptionSommaires: boolean = true;
  public includeEnjeuxSurfaces: boolean = true;
  public includeEvenementObservations: boolean = true;
  public includeObservationChiropteres: boolean = true;
  public includePiliers: boolean = true;
  public includePreconisations: boolean = true;
  public includeProprietaires: boolean = true;
  public includeRefCadastrales: boolean = true;
  public includeSuivis: boolean = true;
  public includeTauxDefruitements: boolean = true;
  public documents: any[] = [];
  public scans: any[] = [];
  public photos: any[] = [];
}

